module.exports = __webpack_public_path__ + "img/daily_necessities_dental.512f29c7.jpg";